import type { ProfileEvent } from '@/components/common/EventPreviewModal';

export function mapInviteEventRow(row: Record<string, unknown>): ProfileEvent {
  return {
    id: String(row.id),
    name: String(row.name ?? ''),
    location: String(row.location ?? ''),
    image: (row.image as string | null | undefined) ?? null,
    status: (row.status as string | undefined) ?? undefined,
    is_public: row.is_public as boolean | undefined,
    is_active: row.is_active as boolean | undefined,
    start_date: (row.start_date as string | null | undefined) ?? null,
    end_date: (row.end_date as string | null | undefined) ?? null,
    created_at: (row.created_at as string | undefined) ?? undefined,
    description: (row.description as string | undefined) ?? undefined,
    departments: Array.isArray(row.departments) ? (row.departments as string[]) : [],
    time_intervals: Array.isArray(row.time_intervals) ? (row.time_intervals as string[]) : [],
    slots: row.slots != null ? Number(row.slots) : undefined,
    created_by: (row.created_by as string | undefined) ?? undefined,
  };
}
